import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 2,
	viewBox: "0 0 16 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 2H0V0H16V2Z",
		fill: "#09334B"
	})
});
export default SvgRemove;
